<template>
	<div class="date-picker-months">
		<div class="date-picker-months__label">Select a Month</div>
		<List class="date-picker-months__list" :listItems="months">
			<template #default="slotProps">
				<Button
					class="date-picker-months__item"
					:id="`${uid}_months`"
					:name="`${uid}_months`"
					:btnClick="() => onClickMonth(slotProps.item)"
					:labelText="slotProps.item.monthName"
					:selectable="true"
					:selected="slotProps.item.index === value"
				/>
			</template>
		</List>
	</div>
</template>

<script>
import List from '@/components/shells/list/list';
import Button from '@/components/forms/button/button';
import dateLocaleMixin from '@/mixins/date-locale-mixin';
import { getMonth } from 'date-fns';

export default {
	name: 'DatePickerMonths',
	mixins: [dateLocaleMixin],
	components: {
		List,
		Button
	},
	data() {
		return {
			months: []
		};
	},
	props: {
		value: {
			type: Number,
			default: () => {
				const currentDate = new Date();
				return getMonth(currentDate);
			}
		},
		/**
		 * values narrow, abbreviated, wide
		 */
		nameWidth: {
			type: String,
			default: 'abbreviated'
		}
	},
	created() {
		//function from mixin
		this.months = this.getMonthListItems();
	},
	methods: {
		getMonthListItems() {
			const listItems = [];
			const monthValues = this.getMonthValues(this.nameWidth);

			for (let index = 0; index < monthValues.length; index++) {
				listItems.push({
					index: index,
					monthName: monthValues[index]
				});
			}

			return listItems;
		},
		onClickMonth(month) {
			this.$emit('input', month.index);
			this.$emit('change', month.index);
		}
	}
};
</script>

<style lang="scss" scoped>
.date-picker-months {
	&__label {
		display: flex;
		align-items: center;
		justify-content: center;
		min-height: 32px;
		margin-bottom: $gutter-lg;
		font-size: $default-font-size + 2;
		font-weight: $medium-font-weight;
		text-align: center;
	}

	&__list {
		@include date-picker-list-grid;
	}
}
</style>
